import {defineStore} from 'pinia';
import {ModuleAccountingObject} from '../moduleConst';
import AccountingObjectAPI from '@/apis/di/accountingObjectAPI';
import {BaseDictionaryStore} from './../baseDictionaryStore';
const accountingObjectStore = new BaseDictionaryStore(AccountingObjectAPI);
export const useAccountingObjectStore = defineStore(ModuleAccountingObject, {
  state: () => ({
    ...accountingObjectStore.state,
    _config: {
      key: 'accounting_object_id',
      code: 'accounting_object_code',
      name: 'accounting_object_name',
      option: {
        key: 'is_employee',
        keyInvalid: 'di_accounting_object_cb',
      },
      table: 'di_accounting_object',
      moduleName: ['Đối tượng', 'Cán bộ'],
      quickFollow: 'active',
      defaultSort: 'accounting_object_code',
    },
    moduleName: 'accountingOject',
  }),
  actions: {...accountingObjectStore.action},
  getters: {
    ...accountingObjectStore.getters,
  },
});
